import Modal from '../modal/Modal';
import ConfirmModalButton from './ConfirmModalButton';
import { Title } from '../typography/Heading';
import style from './confirm-modal.module.less';

const ConfirmModal = ({
    isOpen,
    title,
    message,
    successText,
    secondaryText,
    cancelText,
    onClickSuccess,
    onClickSecondary,
    onClickCancel,
    useActionButton,
}) => {
    return (
        <Modal className={style.wrapper} isOpen={isOpen} onRequestClose={onClickCancel}>
            <div className={style.container}>
                <Title tag={'h2'}>{title}</Title>
                <div dangerouslySetInnerHTML={{ __html: message }} suppressHydrationWarning />
                <div className={style.buttonsContainer}>
                    <ConfirmModalButton
                        title={successText}
                        type={useActionButton ? 'action' : 'success'}
                        onClick={onClickSuccess}
                    />
                    {secondaryText ? (
                        <ConfirmModalButton title={secondaryText} type="cancel" onClick={onClickSecondary} />
                    ) : null}
                    {cancelText ? (
                        <ConfirmModalButton title={cancelText} type="cancel" onClick={onClickCancel} />
                    ) : null}
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
